module.exports = __webpack_public_path__ + "img/exa2.34960f34.png";